import { Modal } from "antd";
import { AnimatePresence, motion } from 'framer-motion';
import { lazy, Suspense, useEffect, useState } from "react";

//STYLES
import { ContainerTimeline } from "./styles";

//APP
import { tipoCard } from "./components/ListaAtividades/meta";
import { useAccess } from "../../../../context/useAccess";
import { localConfig } from "../../../../Configs/localConfig";
import { useGetEquipeCliente } from "../../../../services/Equipe/GET";
import { filtroPadrao, filtrosAvancados } from "./meta";
import { Item__Talhao, useGetAtividadesGerais, useGetDataEmergencia, useGetHistoricoAtividadesPorTalhao, useGetPropriedadesDoCliente } from "../../../../services/atividades/GET";

//COMPONENTS
import Carregando from "../../../../Components/CustomUi/loading";
import { Render } from "../../../../Components/CustomUi/render";
import { Filtros } from "./components/filtros";
import { DrawerCustom } from "../../../../Components/CustomUi/Drawer";
import { FiltroAvancado } from "./components/filtroAvancado";
import { DefautContainer } from "../../../../Components/CustomUi/defaultContainer";

//LAZY COMPONENTS
const Historico = lazy(() => import("./components/Historico").then(module => ({ default: module.Historico })));
const Atividades = lazy(() => import("./components/ListaAtividades").then(module => ({ default: module.Atividades })));
const LinhaDoTempo = lazy(() => import("./components/LinhaDoTempo").then(module => ({ default: module.LinhaDoTempo })));

//#region APP
export const LinhaDoTempoAtv: React.FC = () => {

    //CONST
    const { codSafra } = localConfig();
    const { permission } = useAccess();
    const permissao_atividades = (permission ?? []).find(i => i.cod_rotina === 92);
    const permissao_alterar = permissao_atividades?.alteracao === 1;
    const permissao_excluir = permissao_atividades?.exclusao === 1;

    //#region STATES
    //PROPRIEDADE
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    //TALHÃO
    const [lista_talhoes, setLista_talhoes] = useState<Item__Talhao[]>([]);
    const [cod_talhao_selecionado, setCod_talhao_selecionado] = useState<number>(null);
    const [area_talhao_selecionado, setArea_talhao_selecionado] = useState<string>('');
    //SUBAÁREA
    const [cod_subarea_selecionada, setCod_subarea_selecionada] = useState<number>(null);
    const [area_subarea_selecionada, setArea_subarea_selecionada] = useState<string>('');
    //BUSCA
    const [open_drawer_cadastro, setOpen_drawer_cadastro] = useState<boolean>(false);
    //FILTRO AVANÇADO
    const [open_gaveta_avancado, setOpen_gaveta_avancado] = useState<boolean>(false);
    const [filtrar_titulo, setFiltrar_titulo] = useState<string>('');
    const [filtrar_tipos_operacao, setFiltrar_tipos_operacao] = useState<any[]>([]);
    const [filtrar_intervalo_inicial, setFiltrar_intervalo_inicial] = useState('');
    const [filtrar_intervalo_final, setFiltrar_intervalo_final] = useState('');
    const [transition, setTransition] = useState(true);
    //HITÓRICO DE MODIFICAÇÕES
    const [open_historico, setOpen_historico] = useState<boolean>(false);
    //#endregion

    //#region API
    const { data_equipe_cliente } = useGetEquipeCliente(); //lista equipe
    const { data_emergencia, refetch_emergencia } = useGetDataEmergencia(cod_subarea_selecionada ?? cod_talhao_selecionado); //lista data de emergência do talhão
    const { data_propriedades, carregando_propriedades } = useGetPropriedadesDoCliente(); //lista as propriedades com os talhões
    const { data_atividades, carregando_atividades, refetch_data_atividades, isFetched_atividades } = useGetAtividadesGerais(); //lista todas as atividades de todas as propriedades do cliente
    const { data_historico_atividades, refetch_data_historico_atividades } = useGetHistoricoAtividadesPorTalhao(cod_talhao_selecionado, cod_subarea_selecionada); //lista todas as atividades apenas quando tiver talhão selecionado
    //#endregion

    //#region TRANSITION
    //exibe loading de transição ao aplica filtro
    useEffect(() => {
        setTimeout(() => {
            setTransition(false);
        }, 300);
    }, [cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada]);
    //#endregion

    //#region SELECT FILTROS
    useEffect(() => {
        setCod_talhao_selecionado(null);
        setCod_subarea_selecionada(null);

        /**obtem a lista de talhões da propriedade selecionada */
        if ((data_propriedades ?? []).length > 0) {
            let propriedade_selecionada = (data_propriedades ?? []).filter(i => i?.cod === cod_propriedade_selecionada);
            setLista_talhoes(propriedade_selecionada?.[0]?.talhao ?? []);
        }
    }, [cod_propriedade_selecionada]);

    useEffect(() => {
        /**faz requição das atividades do talhão/subárea para montar o histórico de modificações */
        if (cod_talhao_selecionado !== null) {
            refetch_data_historico_atividades();
        }
    }, [cod_talhao_selecionado, cod_subarea_selecionada, codSafra]);

    useEffect(() => {
        /**faz requição da data de emergência ao alterar o talhão */
        if (cod_talhao_selecionado > 0) {
            refetch_emergencia();
        }
        /**limpa a subárea selecionada ao alterar o talhão */
        setCod_subarea_selecionada(null);
    }, [cod_talhao_selecionado]);

    useEffect(() => {
        /**faz requição da data de emergência ao alterar a subárea */
        if (cod_subarea_selecionada > 0) {
            refetch_emergencia();
        }
    }, [cod_subarea_selecionada]);
    //#endregion


    //#region LIMPAR FILTROS
    useEffect(() => {
        /**limpa o filtro de talhão e subárea ao alterar a safra */
        setCod_talhao_selecionado(null);
        setCod_subarea_selecionada(null);
    }, [codSafra]);

    /**limpa todos os filtros */
    function resetFilters() {
        setFiltrar_titulo(null);
        setFiltrar_tipos_operacao([]);
        setFiltrar_intervalo_inicial('');
        setFiltrar_intervalo_final('');
    }
    //#endregion

    //#region APP
    return (
        <DefautContainer
            title="Atividades - Linha do Tempo"
            id_safra="/atividades/linha-do-tempo"
        >
            <Filtros
                carregando_propriedades={carregando_propriedades}
                cod_propriedade_selecionada={cod_propriedade_selecionada}
                cod_subarea_selecionada={cod_subarea_selecionada}
                cod_talhao_selecionado={cod_talhao_selecionado}
                data_propriedades={data_propriedades}
                lista_talhoes={lista_talhoes}
                permissao_alterar={permissao_alterar}
                setArea_subarea_selecionada={setArea_subarea_selecionada}
                setArea_talhao_selecionado={setArea_talhao_selecionado}
                setCod_propriedade_selecionada={setCod_propriedade_selecionada}
                setCod_subarea_selecionada={setCod_subarea_selecionada}
                setCod_talhao_selecionado={setCod_talhao_selecionado}
                setOpen_drawer_cadastro={setOpen_drawer_cadastro}
                setOpen_gaveta_avancado={setOpen_gaveta_avancado}
                setOpen_historico={setOpen_historico}
                setTransition={setTransition}
            />

            <Render condition={isFetched_atividades && !transition}>
                <ContainerTimeline data-large={tipoCard(cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada) !== 'talhao'}>

                    <Suspense fallback={<>.</>}>
                        <LinhaDoTempo
                            lista_atividades={filtroPadrao((data_atividades ?? []), (data_propriedades ?? []), cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada)}
                        />
                    </Suspense>

                    <Suspense fallback={<>.</>}>
                        <Atividades
                            tipo_card={tipoCard(cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada)}
                            lista_atividades={filtrosAvancados({
                                data_atividades,
                                filtrar_titulo,
                                filtrar_tipos_operacao,
                                filtrar_intervalo_inicial,
                                filtrar_intervalo_final,
                                cod_propriedade_selecionada,
                                cod_talhao_selecionado,
                                cod_subarea_selecionada,
                                data_propriedades
                            })}
                            lista_propriedades={data_propriedades ?? []}
                            carregando_atividades={carregando_atividades}
                            open_drawer_cadastro={open_drawer_cadastro}
                            setOpen_drawer_cadastro={setOpen_drawer_cadastro}
                            cod_talhao_selecionado={cod_subarea_selecionada ?? cod_talhao_selecionado}
                            cod_talhao_pai={cod_talhao_selecionado}
                            refetch_data_atividades={() => { refetch_data_atividades(); refetch_data_historico_atividades(); refetch_emergencia() }}
                            area_talhao_selecionado={cod_subarea_selecionada ? Number(area_subarea_selecionada) : Number(area_talhao_selecionado)}
                            tipo_timeline={"Compacta"}
                            info_emergencia={{ dias: data_emergencia?.dias_apos_plantio ?? null, data: data_emergencia?.data_emergencia_plantio ?? null }}
                            filtrar_titulo={filtrar_titulo}
                            filtrar_tipos_operacao={filtrar_tipos_operacao}
                            filtrar_intervalo_inicial={filtrar_intervalo_inicial}
                            filtrar_intervalo_final={filtrar_intervalo_final}
                            resetFilters={resetFilters}
                            lista_usuarios={data_equipe_cliente}
                            permissao_alterar={permissao_alterar}
                            permissao_excluir={permissao_excluir}
                            cod_subarea_selecionada={cod_subarea_selecionada}
                            lista_atividades_completa={filtrosAvancados({
                                data_atividades,
                                filtrar_titulo,
                                filtrar_tipos_operacao,
                                filtrar_intervalo_inicial,
                                filtrar_intervalo_final,
                                cod_propriedade_selecionada,
                                cod_talhao_selecionado,
                                cod_subarea_selecionada: null,
                                data_propriedades
                            })}
                        />
                    </Suspense>

                </ContainerTimeline>
            </Render>

            {(carregando_atividades || transition) && (
                <AnimatePresence>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        style={{
                            marginTop: 60,
                            width: 'calc(100vw - 300px)',
                            height: 'calc(100vh - 230px)',
                            background: 'rgba(255, 255, 255, 0.7)',
                            position: 'absolute',
                            zIndex: 2,
                        }}
                    >
                        <Carregando
                            animation
                            legenda="Carregando atividades..."
                            justifyContent="center"
                            height={500}
                        />
                    </motion.div>
                </AnimatePresence>
            )}

            <Modal
                title="Filtro avançado"
                open={open_gaveta_avancado}
                onCancel={() => setOpen_gaveta_avancado(false)}
                footer={false}
                width={600}
                destroyOnClose
            >
                <FiltroAvancado
                    onClose={() => setOpen_gaveta_avancado(false)}
                    filtrar_titulo={filtrar_titulo}
                    setFiltrar_titulo={setFiltrar_titulo}
                    filtrar_tipos_operacao={filtrar_tipos_operacao}
                    setFiltrar_tipos_operacao={setFiltrar_tipos_operacao}
                    filtrar_intervalo_inicial={filtrar_intervalo_inicial}
                    setFiltrar_intervalo_inicial={setFiltrar_intervalo_inicial}
                    filtrar_intervalo_final={filtrar_intervalo_final}
                    setFiltrar_intervalo_final={setFiltrar_intervalo_final}
                />

            </Modal>

            <DrawerCustom
                open={open_historico}
                onClose={setOpen_historico}
                destroyOnClose
                title="Histórico de modificações"
            >
                <Suspense fallback={<>.</>}>
                    <Historico
                        lista_atividades={data_historico_atividades}
                    />
                </Suspense>
            </DrawerCustom>

        </DefautContainer>
    )
}
//#endregion